import { useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Homepage.css";

const Homepage = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onHomeLinkClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutLinkClick = useCallback(() => {
    navigate("/aboutus");
  }, [navigate]);

  const onOurProductsTextClick = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopSecondaryClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const onButtonDesktopPrimaryClick = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  const onButtonDesktopPrimary1Click = useCallback(() => {
    navigate("/our-products");
  }, [navigate]);

  const onButtonDesktopPrimary2Click = useCallback(() => {
    navigate("/live-online-classes");
  }, [navigate]);

  return (
    <div className="homepage-div">
      <div className="nav-div">
        <div className="logo1-div" onClick={onLogo1ContainerClick}>
          <img className="vector-icon" alt="" src="../vector.svg" />
          <img className="vector-icon1" alt="" src="../vector1.svg" />
          <img className="vector-icon2" alt="" src="../vector2.svg" />
          <img className="vector-icon3" alt="" src="../vector3.svg" />
          <img className="vector-icon4" alt="" src="../vector4.svg" />
          <img className="vector-icon5" alt="" src="../vector5.svg" />
          <img className="vector-icon6" alt="" src="../vector6.svg" />
          <img className="vector-icon7" alt="" src="../vector7.svg" />
          <img className="vector-icon8" alt="" src="../vector8.svg" />
          <img className="vector-icon9" alt="" src="../vector9.svg" />
          <img className="vector-icon10" alt="" src="../vector10.svg" />
          <img className="vector-icon11" alt="" src="../vector11.svg" />
          <img className="vector-icon12" alt="" src="../vector12.svg" />
          <img className="vector-icon13" alt="" src="../vector13.svg" />
          <img className="vector-icon14" alt="" src="../vector14.svg" />
          <img className="vector-icon15" alt="" src="../vector15.svg" />
          <img className="vector-icon16" alt="" src="../vector16.svg" />
          <img className="vector-icon17" alt="" src="../vector17.svg" />
          <img className="vector-icon18" alt="" src="../vector18.svg" />
          <img className="vector-icon19" alt="" src="../vector19.svg" />
          <img className="vector-icon20" alt="" src="../vector20.svg" />
          <img className="vector-icon21" alt="" src="../vector21.svg" />
          <img className="vector-icon22" alt="" src="../vector22.svg" />
          <img className="vector-icon23" alt="" src="../vector23.svg" />
          <img className="vector-icon24" alt="" src="../vector24.svg" />
          <b className="shuleeazy-b">ShuleEazy</b>
        </div>
        <div className="frame-div">
          <div className="frame-div1">
            <a className="home-a" onClick={onHomeLinkClick}>
              <b className="home-b">Home</b>
            </a>
            <Link className="about" to="/aboutus" onClick={onAboutLinkClick}>
              <b className="about-us">About Us</b>
            </Link>
            <div className="products-div">
              <div className="frame-div2">
                <b className="our-products-b" onClick={onOurProductsTextClick}>
                  Our Products
                </b>
                <img
                  className="outline-24px-chevron-down"
                  alt=""
                  src="../outline-24px--chevrondown.svg"
                />
              </div>
            </div>
            <div className="contact-div">
              <b className="about-us">Contact Us</b>
            </div>
          </div>
          <div className="frame-div3">
            <button
              className="buttondesktopsecondary"
              onClick={onButtonDesktopSecondaryClick}
            >
              <b className="save-and-next">log in</b>
            </button>
            <button
              className="buttondesktopprimary"
              onClick={onButtonDesktopPrimaryClick}
            >
              <b className="save-and-next1">sign up</b>
            </button>
          </div>
        </div>
      </div>
      <div className="hero-section-div">
        <div className="frame-div4">
          <div className="frame-div5">
            <b className="home-b">{`Welcome To ShuleEazy `}</b>
            <b className="making-school-fun-and-accessib">
              Making school fun and accessible to everyone
            </b>
          </div>
          <div className="frame-div6">
            <div className="shuleeazy-is-an-online-school">
              <p className="shuleeazy-is-an">{`ShuleEazy is an online school offering the `}</p>
              <p className="shuleeazy-is-an">{`Competency Based Curriculum (CBC) for students and `}</p>
              <p className="free-mentorship-sessions">
                free Mentorship sessions for teachers, parents and students
              </p>
            </div>
          </div>
          <button
            className="buttondesktopprimary1"
            onClick={onButtonDesktopPrimary1Click}
          >
            <b className="save-and-next1">learn more</b>
            <img
              className="outline-24px-chevron-down"
              alt=""
              src="../outline-24px--arrowright.svg"
            />
          </button>
        </div>
        <div className="hero-image-div">
          <img
            className="undraw-online-learning-re-qw08-icon"
            alt=""
            src="../undraw-online-learning-re-qw08.svg"
          />
          <img
            className="undraw-researching-re-fuod-icon"
            alt=""
            src="../undraw-researching-re-fuod.svg"
          />
          <img
            className="undraw-active-support-re-b7sj-icon"
            alt=""
            src="../undraw-active-support-re-b7sj.svg"
          />
          <img
            className="undraw-online-discussion-re-nn-icon"
            alt=""
            src="../undraw-online-discussion-re-nn7e.svg"
          />
          <div className="undraw-online-test-re-kyfx-div">
            <img className="group-icon" alt="" src="../group.svg" />
            <img className="group-icon1" alt="" src="../group1.svg" />
            <img className="group-icon2" alt="" src="../group2.svg" />
            <img className="group-icon3" alt="" src="../group3.svg" />
            <img className="vector-icon25" alt="" src="../vector25.svg" />
            <img className="vector-icon26" alt="" src="../vector26.svg" />
            <img className="vector-icon27" alt="" src="../vector27.svg" />
            <img className="vector-icon28" alt="" src="../vector28.svg" />
            <img className="vector-icon29" alt="" src="../vector29.svg" />
            <img className="group-icon4" alt="" src="../group4.svg" />
            <div className="logo1-div1">
              <img className="vector-icon" alt="" src="../vector30.svg" />
              <img className="vector-icon1" alt="" src="../vector31.svg" />
              <img className="vector-icon2" alt="" src="../vector32.svg" />
              <img className="vector-icon3" alt="" src="../vector33.svg" />
              <img className="vector-icon4" alt="" src="../vector34.svg" />
              <img className="vector-icon5" alt="" src="../vector35.svg" />
              <img className="vector-icon6" alt="" src="../vector36.svg" />
              <img className="vector-icon7" alt="" src="../vector37.svg" />
              <img className="vector-icon8" alt="" src="../vector38.svg" />
              <img className="vector-icon9" alt="" src="../vector39.svg" />
              <img className="vector-icon10" alt="" src="../vector40.svg" />
              <img className="vector-icon11" alt="" src="../vector41.svg" />
              <img className="vector-icon12" alt="" src="../vector42.svg" />
              <img className="vector-icon13" alt="" src="../vector43.svg" />
              <img className="vector-icon14" alt="" src="../vector44.svg" />
              <img className="vector-icon15" alt="" src="../vector45.svg" />
              <img className="vector-icon16" alt="" src="../vector46.svg" />
              <img className="vector-icon17" alt="" src="../vector47.svg" />
              <img className="vector-icon18" alt="" src="../vector48.svg" />
              <img className="vector-icon19" alt="" src="../vector49.svg" />
              <img className="vector-icon20" alt="" src="../vector50.svg" />
              <img className="vector-icon21" alt="" src="../vector51.svg" />
              <img className="vector-icon22" alt="" src="../vector52.svg" />
              <img className="vector-icon23" alt="" src="../vector53.svg" />
              <img className="vector-icon24" alt="" src="../vector54.svg" />
              <b className="shuleeazy-b1">ShuleEazy</b>
            </div>
          </div>
        </div>
      </div>
      <div className="body-div">
        <div className="why-shuleeazy-div">
          <div className="why-header-div">
            <div className="frame-div7">
              <b className="home-b">Why ShuleEazy</b>
              <div className="line-div" />
            </div>
            <b className="making-a-difference-in-educati">
              Making a difference in Education
            </b>
          </div>
          <div className="why-cards-div">
            <div className="frame-div8">
              <div className="why-cards-div1">
                <b className="about-us">Personalised Attention</b>
                <div className="our-classes-are-designed-for-p">
                  <p className="shuleeazy-is-an">{`Our classes are designed for personalized attention for all our learners. Our small class sizes (10-15 students) enable group dynamic and peer interaction & give room for personalized needs.`}</p>
                  <p className="free-mentorship-sessions">
                    Teachers can easily interact with the students and help them
                    in their areas of weakness.
                  </p>
                </div>
              </div>
              <div className="why-cards-div2">
                <b className="about-us">{`Quality & Affordable Education`}</b>
                <div className="our-classes-are-designed-for-p">
                  <p className="shuleeazy-is-an">
                    We deliver a child-centered, interest and skill-based
                    curriculum that is focused on the holistic development of
                    the individual children.
                  </p>
                  <p className="free-mentorship-sessions">
                    We make education not only fun but also accessible to
                    everyone. The classes are affordable and one can be mentored
                    by experts in the industry for free!
                  </p>
                </div>
              </div>
              <div className="why-cards-div3">
                <b className="about-us">Quality Teachers</b>
                <div className="our-classes-are-designed-for-p">
                  <p className="shuleeazy-is-an">
                    Our accredited and vetted teachers are driven to help our
                    students flourish and thrive. They inspire, instill
                    confidence, encourage, know, and believe in their students.
                  </p>
                  <p className="free-mentorship-sessions">
                    They are the best in what they do and are highly trained in
                    the Competency Based Curriculum(CBC)
                  </p>
                </div>
              </div>
            </div>
            <div className="frame-div8">
              <div className="why-cards-div1">
                <b className="about-us">Quality Mentors</b>
                <div className="our-classes-are-designed-for-p">
                  <p className="shuleeazy-is-an">{`We have professionals in different fields who volunteer to mentor students, teachers and parents in their areas of expertise. `}</p>
                  <p className="free-mentorship-sessions">
                    These are professionals who want to turn their passions into
                    conversations, friendships and networks. They help those
                    interested in their field understand it and start off.
                  </p>
                </div>
              </div>
              <div className="why-cards-div2">
                <b className="about-us">Progress Tracking</b>
                <div className="our-classes-are-designed-for-p">
                  <p className="shuleeazy-is-an">{`Our platform allows Transparent Daily Progress Tracking for parents: with daily diary entries, Assignment & Attendance tracking and merits.`}</p>
                  <p className="free-mentorship-sessions">
                    Parents can check the performance of their children, the
                    assignments given and also whether they are attending the
                    classes, all at the comfort of their homes.
                  </p>
                </div>
              </div>
              <div className="why-cards-div3">
                <b className="about-us">Amazing Community</b>
                <div className="our-classes-are-designed-for-p5">
                  <p className="shuleeazy-is-an">
                    We offer a platform where the learners, teachers, parents
                    and mentors can all interact, share different ideas and do
                    various projects together.
                  </p>
                  <p className="shuleeazy-is-an">
                    This is done using slack, where we have socialization beyond
                    classroom learning.
                  </p>
                  <p className="free-mentorship-sessions">
                    A group can agree among themselves either to meet virtually
                    or physically.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="what-we-offer">
          <div className="why-header-div">
            <div className="frame-div7">
              <b className="home-b">What we offer</b>
              <div className="line-div" />
            </div>
            <b className="making-a-difference-in-educati">
              Discover our Products
            </b>
          </div>
          <div className="frame-div12">
            <div className="frame-div13">
              <img
                className="live-classes-icon"
                alt=""
                src="../live-classes.svg"
              />
              <div className="frame-div14">
                <div className="frame-div15">
                  <div className="frame-div16">
                    <b className="home-b">Live Online Classes</b>
                    <b className="impactful-live-online-classes">
                      <p className="shuleeazy-is-an">{`Impactful live online classes `}</p>
                      <p className="free-mentorship-sessions">
                        that focuses on your child’s growth
                      </p>
                    </b>
                  </div>
                  <div className="shuleeazy-provides-a-learning">
                    <p className="shuleeazy-is-an">{`ShuleEazy provides a learning environment that encourages students to take charge of their learning, engage with their classmates and teachers to solve issues, and think strategically. `}</p>
                    <p className="free-mentorship-sessions">
                      Competency Based Curriculum (CBC) is used.
                    </p>
                  </div>
                </div>
                <button
                  className="buttondesktopprimary1"
                  onClick={onButtonDesktopPrimary2Click}
                >
                  <b className="save-and-next1">Learn more</b>
                  <img
                    className="outline-24px-chevron-down"
                    alt=""
                    src="../outline-24px--arrowright1.svg"
                  />
                </button>
              </div>
            </div>
            <div className="frame-div13">
              <div className="frame-div18">
                <div className="frame-div15">
                  <div className="frame-div16">
                    <b className="home-b">SMS Platform</b>
                    <b className="impactful-live-online-classes">
                      Build student knowledge through SMS
                    </b>
                  </div>
                  <div className="shuleeazy-provides-a-learning">
                    <p className="shuleeazy-is-an">{`We are aware that a huge population doesn’t have smartphones or the internet, that’s why as ShuleEazy we have also built an SMS Platform. `}</p>
                    <p className="free-mentorship-sessions">
                      It is a skill-building platform possible with the simplest
                      feature phone.
                    </p>
                  </div>
                </div>
                <button className="buttondesktopprimary1">
                  <b className="save-and-next1">Learn more</b>
                  <img
                    className="outline-24px-chevron-down"
                    alt=""
                    src="../outline-24px--arrowright1.svg"
                  />
                </button>
              </div>
              <img
                className="sms-platform-icon"
                alt=""
                src="../sms-platform.svg"
              />
            </div>
            <div className="frame-div13">
              <img
                className="live-classes-icon"
                alt=""
                src="../mentorship-sessions.svg"
              />
              <div className="frame-div18">
                <div className="frame-div15">
                  <div className="frame-div16">
                    <b className="home-b">Mentorship Sessions</b>
                    <b className="impactful-live-online-classes">
                      <p className="shuleeazy-is-an">{`learn and grow with help from `}</p>
                      <p className="free-mentorship-sessions">
                        world-class mentors for free
                      </p>
                    </b>
                  </div>
                  <div className="shuleeazy-provides-a-learning">
                    <p className="shuleeazy-is-an">
                      Once a member of ShuleEazy, you can book and meet mentors
                      for 1:1 mentorship.
                    </p>
                    <p className="shuleeazy-is-an">{`Mentors are professionals who volunteer to turn their passions into conversations, friendships and networks. `}</p>
                    <p className="free-mentorship-sessions">
                      Students, teachers and parents can book sessions with the
                      mentors
                    </p>
                  </div>
                </div>
                <button className="buttondesktopprimary1">
                  <b className="save-and-next1">Learn more</b>
                  <img
                    className="outline-24px-chevron-down"
                    alt=""
                    src="../outline-24px--arrowright1.svg"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="value-proposition-div">
          <div className="frame-div25">
            <b className="home-b">Value Proposition</b>
            <div className="line-div" />
          </div>
          <div className="frame-div26">
            <div className="vp-learners">
              <b className="home-b">To Our Learners</b>
              <div className="frame-div27">
                <div className="learners-div">
                  <div className="vp-card-div">
                    <div className="personalized-div">
                      <img
                        className="personalized-icon"
                        alt=""
                        src="../personalized@2x.png"
                      />
                    </div>
                    <div className="frame-div28">
                      <b className="about-us">PERSONALIZED</b>
                      <div className="learning-with-arifu-is-as-easy">{`Whether learning Mathematics, English, Coding or Music, our expertly-crafted content is designed to meet the unique needs of each individual. `}</div>
                    </div>
                  </div>
                  <div className="vp-card-div">
                    <div className="personalized-div">
                      <img
                        className="personalized-icon"
                        alt=""
                        src="../easy@2x.png"
                      />
                    </div>
                    <div className="frame-div28">
                      <b className="about-us">EASY TO USE</b>
                      <div className="learning-with-arifu-is-as-easy">
                        Learning with ShuleEazy is very easy. The SMS platform
                        is accessible on any phone, with or without internet and
                        the live online classes are easily accessible once one
                        logs in to the web platform.
                      </div>
                    </div>
                  </div>
                  <div className="vp-card-div">
                    <div className="personalized-div">
                      <img
                        className="personalized-icon"
                        alt=""
                        src="../web-accessibility@2x.png"
                      />
                    </div>
                    <div className="frame-div28">
                      <b className="about-us">OPEN ACCESS</b>
                      <div className="learning-with-arifu-is-as-easy">
                        Learning from our platforms is affordable and open to
                        everyone. Most of the content taught and resources
                        shared will be sponsored by our partners.
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  className="frame-icon"
                  alt=""
                  src="../frame-11766@2x.png"
                />
              </div>
            </div>
            <div className="vp-partners">
              <b className="home-b">To Our Partners</b>
              <div className="frame-div31">
                <img
                  className="frame-icon1"
                  alt=""
                  src="../frame-11767@2x.png"
                />
                <div className="learners-div1">
                  <div className="vp-card-div">
                    <div className="personalized-div">
                      <img
                        className="personalized-icon"
                        alt=""
                        src="../increase@2x.png"
                      />
                    </div>
                    <div className="frame-div28">
                      <b className="about-us">SCALE</b>
                      <div className="learning-with-arifu-is-as-easy">
                        With mobile online training and marketing at 1-10% the
                        cost of traditional in-person models, you can afford to
                        engage millions of people in your target audience.
                      </div>
                    </div>
                  </div>
                  <div className="vp-card-div">
                    <div className="personalized-div">
                      <img
                        className="personalized-icon"
                        alt=""
                        src="../web-advertising@2x.png"
                      />
                    </div>
                    <div className="frame-div28">
                      <b className="about-us">MARKETING</b>
                      <div className="learning-with-arifu-is-as-easy">
                        Deliver awareness and knowledge that drives usage of
                        essential skills and high impact services.
                      </div>
                    </div>
                  </div>
                  <div className="vp-card-div">
                    <img className="data-icon" alt="" src="../data.svg" />
                    <div className="frame-div28">
                      <b className="about-us">CAPTURE DATA</b>
                      <div className="learning-with-arifu-is-as-easy">
                        Access real-time analytics and feedback to better
                        understand your target audiences and design a better
                        solutions for them.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-div">
          <div className="frame-div35">
            <img
              className="outline-24px-chevron-down"
              alt=""
              src="../antdesigncopyrightoutlined.svg"
            />
            <b className="home-b">2022 ShuleEazy, All Rights Reserved</b>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
